import React from 'react';
import { Col, Form } from 'react-bootstrap';

const CustomerInfoFormSection = ({ register, errors, states, countries, includeName = true }) => {
    return (
        <>
            {includeName && (
                <>
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label className="text-dark">
                                First Name<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="firstName"
                                placeholder="First Name"
                                {...register('firstName', { required: 'First name is required' })}
                                isInvalid={!!errors?.firstName}
                            />
                            <p className="text-danger">{errors?.firstName?.message}</p>
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label className="text-dark">
                                Last Name<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="lastName"
                                placeholder="Last Name"
                                {...register('lastName', { required: 'Last name is required' })}
                                isInvalid={!!errors?.lastName}
                            />
                            <p className="text-danger">{errors?.lastName?.message}</p>
                        </Form.Group>
                    </Col>
                </>
            )}
            <Col xs={12}>
                <Form.Group>
                    <Form.Label className="text-dark">
                        Address Line 1<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="street"
                        placeholder="Address Line 1"
                        {...register('street', { required: 'Address is required' })}
                        isInvalid={!!errors?.street}
                    />
                    <p className="text-danger">{errors?.street?.message}</p>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label className="text-dark">Address Line 2</Form.Label>
                    <Form.Control type="text" name="street2" placeholder="Address Line 2" {...register('street2')} />
                </Form.Group>
            </Col>
            <Col xs={4}>
                <Form.Group>
                    <Form.Label className="text-dark">
                        City<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="city"
                        placeholder="City"
                        {...register('city', { required: 'City is required' })}
                        isInvalid={!!errors?.city}
                    />
                    <p className="text-danger">{errors?.city?.message}</p>
                </Form.Group>
            </Col>
            <Col xs={4}>
                <Form.Group>
                    <Form.Label className="text-dark">
                        State<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        as="select"
                        name="state"
                        {...register('state', { required: 'State is required' })}
                        isInvalid={!!errors?.state}
                    >
                        {states.map((r, i) => (
                            <option key={i} value={r.abbreviation}>
                                {r.abbreviation}
                            </option>
                        ))}
                    </Form.Control>
                    <p className="text-danger">{errors?.state?.message}</p>
                </Form.Group>
            </Col>
            <Col xs={4}>
                <Form.Group>
                    <Form.Label className="text-dark">
                        Zip<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="zip"
                        placeholder="Zip"
                        {...register('zip', { required: 'Enter proper zip' })}
                        isInvalid={!!errors?.zip}
                    />
                    <p className="text-danger">{errors?.zip?.message}</p>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label className="text-dark">Country</Form.Label>
                    <Form.Control as="select" name="country" {...register('country')}>
                        {countries.map((r, i) => (
                            <option key={i} value={r.alpha2Code}>
                                {r.name}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label className="text-dark">
                        Company<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="company"
                        placeholder="Company"
                        {...register('company', { required: 'Company is required' })}
                        isInvalid={!!errors?.company}
                    />
                    <p className="text-danger">{errors?.company?.message}</p>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label className="text-dark">
                        Email<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="email"
                        placeholder="Email"
                        {...register('email', { required: 'Enter proper email' })}
                        isInvalid={!!errors?.email}
                    />
                    <p className="text-danger">{errors?.email?.message}</p>
                </Form.Group>
            </Col>
        </>
    );
};

export default CustomerInfoFormSection;
